const tachyons = {}

tachyons.output = 'w-100 pa2 br2 bg-white bb b--moon-gray bg-dark-gray';
tachyons.input = 'input-reset w-100 pa2 br2 bg-white bb b--moon-gray bg-dark-gray';
tachyons.commonLabel = 'pl1 b';
tachyons.formErrors = 'f7 form-errors';
tachyons.formHelp = 'mh2 ph1 f7';

tachyons.button = 'h-100 bn link ph2 pv2 mb2 black-70 br-pill bg-blue pointer';
tachyons.secondaryButton = 'w4 h-100 bn f6 link ph2 pv2 mb2 black-70 br-pill bg-light-gray pointer';
tachyons.buttonCustom = 'bn ph3 pv2 mb2 pointer';

tachyons.column = 'mr-auto ml-auto fn w-80-ns ph3 ph0-ns';
tachyons.innerColumn = 'w-100 w-80-m w-60-l ml-auto mr-auto fn flex flex-wrap';
tachyons.fullWidthSection = 'w-100';
tachyons.center = 'mr-auto ml-auto fn';
tachyons.topBar = 'bb b--moon-gray w-100 h3 flex items-center fixed bg-white z-5 black-70 z-999 shadow-4';
tachyons.topBarInner = 'mr-auto ml-auto fn w-100 w-80-ns h-100 flex items-center justify-between ph3 ph0-ns';
tachyons.bottomBar = 'w-100 flex items-center fixed bg-white z-5 black-70 z-5';

tachyons.columna = 'w-100 ph3 ph0-ns flex justify-around';
tachyons.columnaInterna = 'w-100 w-60-m w-50-l flex flex-wrap';

tachyons.botonPeligro = 'h-100 bn link ph2 pv2 mb2 black-70 br-pill bg-hot-pink pointer white';

export default tachyons
